import React, { useEffect } from 'react';
import './NotificationPopup.scss';

interface NotificationPopupProps {
  message: string;
  visible: boolean;
  onClose: () => void;
}

const NotificationPopup: React.FC<NotificationPopupProps> = ({ message, visible, onClose }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(onClose, 3000); // Hide after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  return (
    <div className={`notification-popup ${visible ? 'show' : ''}`}>
      <span>{message}</span>
      <button onClick={onClose} className="close-btn">X</button>
    </div>
  );
};

export default NotificationPopup;